// extracted by mini-css-extract-plugin
module.exports = {"base":"Link_base__2nyAq"};